import { ConfigQuery as SourceConfigQuery } from 'SourceQuery/Config.query';

/** @namespace Pwa/Query/Config/Query */
export class ConfigQuery extends SourceConfigQuery {
    _getStoreListFields() {
        return [...super._getStoreListFields(), 'id'];
    }

    _getStoreConfigFields() {
        return [
            ...super._getStoreConfigFields(),
            'postcode',
            'city',
            'street_line1',
            'street_line2',
            'phone',
            'email',
            'product_url_suffix',
            'payment_ca_raty_description_pdp',
            'payment_ca_raty_psp_id',
            'minimum_password_length',
            'required_character_classes_number',
            'omnibus_enable_front',
        ];
    }
}

export default new ConfigQuery();
